export default "__VITE_ASSET__ybW9$q6e7Ao8hj2fFIQqDw__"